import styled, { css } from 'styled-components';
import { color, fontSize, fontWeight, screen, spacing } from '../../theme';
import { ConfirmModalIconStyle } from './ConfirmModal.types';

const iconVariants: Record<
  ConfirmModalIconStyle,
  {
    color: string | ((key: any) => any);
  }
> = {
  warning: {
    color: color('notice_500')
  },

  info: {
    color: color('info_500')
  }
};

export const StyledWrapper = styled.div``;

export const StyledIcon = styled.div<{
  variant: ConfirmModalIconStyle;
}>`
  color: ${color('notice_500')};
  font-size: ${fontSize('xl7')};
  text-align: center;

  ${({ variant }) =>
    variant &&
    iconVariants[variant] &&
    css`
      color: ${iconVariants[variant].color} !important;
    `}
`;

export const StyledTitle = styled.h1`
  font-size: ${fontSize('lg')};
  font-weight: ${fontWeight('black')};
  color: ${color('midnight_500')};
  text-align: center;

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('xl3')};
  }
`;

export const StyledText = styled.p`
  font-size: ${fontSize('sm')};
  font-weight: ${fontWeight('medium')};
  color: ${color('midnight_800')};
  text-align: center;
  margin-bottom: ${spacing('xl4')};

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('lg')};
  }
`;

export const StyledActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${spacing('md')};
  margin-top: ${spacing('md')};

  button {
    flex-grow: 1;
    max-width: 50%;
  }

  @media (max-width: ${screen('md')}) {
    display: block;

    button {
      display: block;
      width: 100%;
      max-width: unset;
      margin-bottom: ${spacing('md')};
    }
  }
`;
